var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.880432C4.47656 0.880432 0 5.35699 0 10.8804C0 16.4039 4.47656 20.8804 10 20.8804C15.5234 20.8804 20 16.4039 20 10.8804C20 5.35699 15.5234 0.880432 10 0.880432ZM15.707 8.58746L8.70703 15.5875C8.51172 15.7828 8.25781 15.8804 8 15.8804C7.74219 15.8804 7.48828 15.7828 7.29297 15.5875L4.29297 12.5875C3.90234 12.1968 3.90234 11.564 4.29297 11.1734C4.68359 10.7828 5.31641 10.7828 5.70703 11.1734L8 13.4664L14.293 7.1734C14.6836 6.78278 15.3164 6.78278 15.707 7.1734C16.0977 7.56403 16.0977 8.19684 15.707 8.58746Z",
    fill: "#00A3FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircle);
export default __webpack_public_path__ + "static/media/arrow-circle.9366fbf7983b03ff24542ecba5adde51.svg";
export { ForwardRef as ReactComponent };